import type { IPrimer } from '../../../../Model/index.js'
import type { BaseModalProps } from '../../../Modal/BaseModal.js'
import { BaseModal } from '../../../Modal/BaseModal.js'
import { PrimerChoice } from '../../../Component/PrimerChoice.tsx'

export interface PrimerChoiceModalProps {
  candidates: IPrimer[]
  onChoose: (primer: IPrimer) => void
}

export const PrimerChoiceModal = (props: PrimerChoiceModalProps & BaseModalProps) => (
  <BaseModal isOpen={props.isOpen} onClose={props.onClose} testId={'primer-choice-modal'}>
    <div className="modal-box w-full max-w-xl">
      <h3 className="mb-3 text-lg font-bold">Which primer pair is this?</h3>
      <PrimerChoice
        candidates={props.candidates}
        confirmLabel="Use this pair and continue"
        onChoose={(primer) => {
          props.onClose()
          props.onChoose(primer)
        }}
      />
    </div>
  </BaseModal>
)
